// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyCrcPMAqtijdD8_MHbCEtUy5Z2Cgf2TdhM",
    authDomain: "twitter-clone-ec0cd.firebaseapp.com",
    databaseURL: "https://twitter-clone-ec0cd.firebaseio.com",
    projectId: "twitter-clone-ec0cd",
    storageBucket: "twitter-clone-ec0cd.appspot.com",
    messagingSenderId: "673263434753",
    appId: "1:673263434753:web:46f23b9f1461411717d400",
    measurementId: "G-JX7HSG9VSF"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;